// Table of Contents items
export const subContentItemsPPLA = [
  {
    id: "ppl-a/requirements-and-qualifications",
    title: "Requirements and qualifications",
  },
  { id: "ppl-a/trial-flight", title: "First step - Trial flight" },
  {
    id: "ppl-a/medical-examination",
    title: "Second step – Medical examination",
  },
  { id: "ppl-a/training", title: "PPL Training" },
  { id: "ppl-a/cost", title: "Cost" },
  { id: "ppl-a/beyond-your-ppl", title: "Beyond your PPL" },
  { id: "ppl-a/career-beyond-your-ppl", title: "A Career beyond your PPL" },
  { id: "ppl-a/faqs", title: "FAQs" },
];

export const subSubContentItemsPPLA = [
  {
    id: "ppl-a-training-theoretical-knowledge",
    title: "Theoretical knowledge",
  },
  {
    id: "ppl-a/training/flight-radiotelephony-operators-license",
    title: "Flight radiotelephony operator's licence",
  },
  { id: "ppl-a/training/flight-training", title: "Flight training" },
  { id: "ppl-a/training/skills-test", title: "Skills test" },
];

export const subContentItemsPPLH = [
  {
    id: "ppl-h/requirements-and-qualifications",
    title: "Requirements and qualifications",
  },
  {
    id: "ppl-h/trial-flight",
    title: "First step - Trial flight",
  },
  {
    id: "ppl-h/medical-examination",
    title: "Second step – Medical examination",
  },
  {
    id: "ppl-h/training",
    title: "PPL(H) Training",
  },
  {
    id: "ppl-h/cost",
    title: "Cost",
  },
  {
    id: "ppl-h/beyond-your-ppl",
    title: "Beyond your PPL(H)",
  },
  {
    id: "ppl-h/career-beyond-your-ppl",
    title: "A Career beyond your PPL(H)",
  },
  {
    id: "ppl-h/faqs",
    title: "FAQs",
  },
];

export const subSubContentItemsPPLH = [
  {
    id: "ppl-h/training/theoretical-knowledge",
    title: "Theoretical knowledge",
  },
  {
    id: "ppl-h/training/flight-radiotelephony-operators-license",
    title: "Flight radiotelephony operator's licence",
  },
  { id: "ppl-h/training/flight-training", title: "Flight training" },
  { id: "ppl-h/training/skills-test", title: "Skills test" },
];

export const subContentItemsLAPLA = [
  {
    id: "lapl-a/requirements-and-qualifications",
    title: "Requirements and qualifications",
  },
  {
    id: "lapl-a/trial-flight",
    title: "First step - Trial flight",
  },
  {
    id: "lapl-a/medical-examination",
    title: "Second step – Medical examination",
  },
  {
    id: "lapl-a/training",
    title: "LAPL Training",
  },
  {
    id: "lapl-a/cost",
    title: "Cost",
  },
  {
    id: "lapl-a/career-beyond-your-lapl",
    title: "A Career beyond your LAPL(A)",
  },
];

export const subContentItemsNPPL = [
  {
    id: "nppl/requirements-and-qualifications",
    title: "Requirements and qualifications",
  },
  {
    id: "nppl/trial-flight",
    title: "First step - Trial flight",
  },
  {
    id: "nppl/medical-examination",
    title: "Second step – Medical examination",
  },
  {
    id: "nppl/training",
    title: "NPPL Training",
  },
  {
    id: "nppl/cost",
    title: "Cost",
  },
  {
    id: "nppl/career-beyond-your-nppl",
    title: "A Career beyond your NPPL(A)",
  },
];

// Callout content
export const calloutTrialFlight = {
  body: [
    {
      text: "Top Tip: Speak to the club members and students to gain additional insight.",
    },
  ],
};

export const calloutCopyMedicalExamination = {
  body: [
    {
      text: "If your ultimate ambition is to pursue a career as a pilot after your PPL, instead of a Class 2, it is strongly recommended to obtain your initial Part MED Class 1 Certificate at this point.",
    },
    {
      text: "Although obtaining a Class 1 medical represents a sizeable financial undertaking (approximately £660) it is important to determine whether you are medically able to perform your desired job role prior to investing significant amounts of time and money.",
    },
  ],
};

export const calloutCopyMedicalExaminationPPLH = {
  body: [
    {
      text: "If your ultimate ambition is to pursue a career as a pilot after your PPL(H), instead of a Class 2, it is strongly recommended to obtain your initial Part MED Class 1 Certificate at this point.",
    },
    {
      text: "Although obtaining a Class 1 medical represents a sizeable financial undertaking (approximately £660) it is important to determine whether you are medically able to perform your desired job role prior to investing significant amounts of money and time. ",
    },
  ],
};

export const calloutCopyMedicalExaminationLAPL = {
  body: [
    {
      text: "If your ultimate ambition is to pursue a career as a pilot after your LAPL, instead of a LAPL medical, it is strongly recommended to obtain your initial Part MED Class 1 Certificate at this point.",
    },
    {
      text: "Although obtaining a Class 1 medical represents a sizeable financial undertaking (approximately £660) it is important to determine whether you are medically able to perform your desired job role prior to investing significant amounts of time and money.",
    },
  ],
};

export const calloutFlightTrainingPPLA = {
  body: [
    {
      text: "Top Tip: It is common for most students to require more than 45 hours of flight training, so budgeting accordingly is essential.",
    },
  ],
};

export const calloutFlightTrainingPPLA2 = {
  body: [
    {
      text: "If you hold a Sailplane Pilot Licence (SPL) you will be credited with 10% of your total flight time as Pilot In Command (PIC) up to a maximum of 10 hours.",
    },
  ],
};

export const calloutFlightTrainingLAPLA = {
  body: [
    {
      text: "Top Tip: It is common for most students to require more than 30 hours of flight training, so budgeting accordingly is essential.",
    },
  ],
};

export const calloutFlightTrainingPPLH2 = {
  body: [
    {
      text: "If you hold a pilot's licence for another type of aircraft (not including balloons) you will be credited with 10% of your total flight time as Pilot In Command (PIC) up to a maximum of 6 hours.",
    },
  ],
};

// Bullet point lists
export const theoreticalKnowledgeBulletPoints = [
  { text: "Air Law" },
  { text: "Human Performance" },
  { text: "Meteorology" },
  { text: "Communications" },
  { text: "Navigation" },
  { text: "Principles of Flight" },
  { text: "Operational Procedures" },
  { text: "Flight Performance and Planning" },
  { text: "Aircraft General Knowledge" },
];

export const theoreticalKnowledgeBulletPointsNPPL = [
  { text: "Avation Law" },
  { text: "Human Factors" },
  { text: "Meteorology" },
  { text: "Navigation" },
  { text: "Aircraft Technical" },
];

export const flightTrainingBulletPoints = [
  { text: "25 hours of dual flight instruction" },
  {
    text: "10 hours of supervised solo flight time, including at least 5 hours of solo cross-country flight time with at least 1 cross country flight of at least 270 km (150 NM) that includes full stop landings at 2 aerodromes different from the departure aerodrome.",
  },
];

export const flightTrainingBulletPointsPPLH = [
  { text: "25 hours of dual flight instruction" },
  {
    text: "10 hours of supervised solo flight time, including at least 5 hours of solo cross-country flight time with at least 1 cross country flight of at least 185 km (100 NM) that includes full stop landings at 2 aerodromes different from the departure aerodrome.",
  },
  {
    text: "35 of the 45 hours of flight instruction have to be completed on the same type of helicopter used for the skill test.",
  },
];

export const flightTrainingBulletPointsLAPL = [
  { text: "15 hours of dual flight instruction" },
  {
    text: "6 hours of supervised solo flight time, including at least 3 hours of solo cross-country flight time with at least 1 cross country flight of at least 150 km (80 NM) that includes a full stop landing at 1 aerodrome different from the departure aerodrome.",
  },
];

export const flightTrainingBulletPointsNPPL = [
  {
    text: "25 hours of dual flight instruction, including at least 5 hours of dual navigation flight time",
  },
  {
    text: "10 hours of supervised solo flight time, including at least 3 hours of solo navigation flight time",
  },
];

// FAQ content
export const choosingACourseFAQs = [
  {
    heading: "Is a PPL(H) useful if I want to become a military pilot?",
    body: "Any flying experience is useful however a PPL is not a requirement for military flying. Military streaming will happen after Elementary Flying Training (EFT), so there is no guarantee that a PPL(H) will mean you are sent rotary. Military flying rates are very low due to MFTS issues and lengthy holds between courses. Many military bases have flying clubs which offer discounted rates to service personnel. These tend to be Cessna 152 or PA28 aircraft, so a PPL(A) may actually be more useful just to stay flying while waiting for military flying courses.",
  },
  {
    heading: "Is a PPL(H) harder to achieve than a PPL(A)?",
    body: "Financially, yes! Also, helicopters are complex and unique aircraft. They require good coordination and situational awareness to operate them effectively and also avoid dangerous situations like vortex ring. Students will need to learn to hover the aircraft, which is considered more challenging than fixed wing take off/landing. A good appreciation of wind effects, weather, power requirements and low speed flying is also required, which can make PPL(H) flying more challenging than the PPL(A) equivalent. Autorotations are more challenging to manage than aeroplane glide circuits. On the plus side, helicopters spend a lot of time flying into challenging locations like confined areas, unprepared sites, mountains, cliffs, offshore vessels, etc. The trade-off for a higher workload and higher risk flying is that the jobs can be a lot more varied and interesting!",
  },
  {
    heading: "Should I do a PPL(A) if I can't afford a PPL(H)?",
    body: "A PPL(A) will still allow you to gain valuable aviation experience and there are some credits available for holding the PPL(A) should you wish to obtain a PPL(H) at a more financially viable time in the future. There are many PPL(A) scholarships available to support your flying ambitions and provide a practical start into aviation. It is not advisable to start the PPL(H) until you have sufficient funds to ensure some continuity of flying, or it may be a struggle and cost more in the long run. A trial flight is certainly encouraged, however do not plan occasional trips once committed to obtaining your licence otherwise progress will be challenging, particularly in the early days.",
  },
];
